/**
 * Module to show Recently Viewed Products
 * Rewritten to use localStorage instead of cookies
 * (cookies blocked by modern browser privacy policies)
 */

Shopify.Products = (function() {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        onComplete: null
    };
    var productHandles = [];
    var wrapper = null;
    var template = null;
    var shown = 0;

    var storage = {
        key: "shopify_recently_viewed",
        write: function(items) {
            try {
                localStorage.setItem(this.key, JSON.stringify(items));
            } catch(e) {}
        },
        read: function() {
            try {
                var data = localStorage.getItem(this.key);
                return data ? JSON.parse(data) : [];
            } catch(e) {
                return [];
            }
        },
        destroy: function() {
            try { localStorage.removeItem(this.key); } catch(e) {}
        },
        remove: function(handle) {
            var items = this.read();
            var idx = jQuery.inArray(handle, items);
            if (idx !== -1) {
                items.splice(idx, 1);
                this.write(items);
            }
        }
    };

    var showComplete = function() {
        wrapper.show();
        if (config.onComplete) {
            try { config.onComplete(); } catch(e) {}
        }
    };

    var fetchAndRender = function() {
        if (productHandles.length && shown < config.howManyToShow) {
            jQuery.ajax({
                dataType: "json",
                url: "/products/" + productHandles[0] + ".js",
                cache: false,
                success: function(product) {
                    template.tmpl(product).appendTo(wrapper);
                    productHandles.shift();
                    shown++;
                    fetchAndRender();
                },
                error: function() {
                    storage.remove(productHandles[0]);
                    productHandles.shift();
                    fetchAndRender();
                }
            });
        } else {
            if (shown > 0) showComplete();
        }
    };

    return {
        resizeImage: function(src, size) {
            if (size == null) return src;
            if (size == "master") return src.replace(/http(s)?:/, "");
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (match != null) {
                var parts = src.split(match[0]);
                return (parts[0] + "_" + size + match[0]).replace(/http(s)?:/, "");
            }
            return null;
        },

        showRecentlyViewed: function(opts) {
            opts = opts || {};
            jQuery.extend(config, opts);
            productHandles = storage.read();
            template = jQuery("#" + config.templateId);
            wrapper = jQuery("#" + config.wrapperId);
            config.howManyToShow = Math.min(productHandles.length, config.howManyToShow);
            if (config.howManyToShow && template.length && wrapper.length) {
                fetchAndRender();
            }
        },

        getConfig: function() { return config; },
        clearList: function() { storage.destroy(); },

        recordRecentlyViewed: function(opts) {
            opts = opts || {};
            jQuery.extend(config, opts);
            var items = storage.read();
            if (window.location.pathname.indexOf("/products/") !== -1) {
                var match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (match) {
                    var handle = match[1];
                    var idx = jQuery.inArray(handle, items);
                    if (idx === -1) {
                        items.unshift(handle);
                        items = items.splice(0, config.howManyToStoreInMemory);
                    } else {
                        items.splice(idx, 1);
                        items.unshift(handle);
                    }
                    storage.write(items);
                }
            }
        }
    };
})();


var selectors = {
    wrapperSelector: '#recently-viewed-products'
};
selectors.limit = parseInt(jQuery(selectors.wrapperSelector).parent().data('limit'));

Shopify.Products.recordRecentlyViewed();
Shopify.Products.showRecentlyViewed({
    howManyToShow: 4,
    onComplete: function() {
        jQuery(selectors.wrapperSelector).parent().show();
    }
});
